import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "basic-layout" }
const _hoisted_2 = { class: "main-content" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import GloablHeader from '../components/GloablHeader.vue';
import GlobalFooter from '../components/GlobalFooter.vue';
import FloatingContactButtons from '../components/FloatingContactButtons.vue';
import CarouselComponent from '../components/CarouselComponent.vue';
import ProductDisplay from '../components/ProductDisplay.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {

const route = useRoute();

// 判断是否是详情页（产品详情或菜单详情或体验申请表单或FAQ页面）
const isProductDetailPage = computed(() => {
  return route.path === '/product-detail' || route.path === '/topic-detail' || route.path === '/application-form' || route.path === '/faq';
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GloablHeader),
    (!isProductDetailPage.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(CarouselComponent),
          _createVNode(ProductDisplay)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createVNode(GlobalFooter),
    _createVNode(FloatingContactButtons)
  ]))
}
}

})